import { Module, useStore } from "vuex";
import { State } from "@/store";
import Message from "@/message";

export interface ModuleState {
  messages: Map<number, Message>;
  messagesCounter: number;
}

export const MessageModule: Module<ModuleState, State> = {
  namespaced: true,
  state: {
    messages: new Map(),
    messagesCounter: 0,
  },
  mutations: {
    removeMessage(state, messageId) {
      state.messages.delete(messageId);
    },
    addMessage(state, message: Message) {
      const messageId = state.messagesCounter++;
      state.messages.set(messageId, message);
      if (message.ttl !== undefined) {
        setTimeout(() => state.messages.delete(messageId), message.ttl * 1000);
      }
    },
  },
};

type messageFn = (message: string, ttl?: number) => void;
interface MessageFns {
  addSuccess: messageFn;
  addError: messageFn;
  addWarning: messageFn;
  addInformation: messageFn;
}

export function useMessages(store = useStore()): MessageFns {
  return {
    addSuccess: (message: string, ttl = 5) =>
      store.commit("msg/addMessage", { kind: "success", message, ttl }),
    addError: (message: string, ttl?: number) =>
      store.commit("msg/addMessage", { kind: "error", message, ttl }),
    addWarning: (message: string, ttl?: number) =>
      store.commit("msg/addMessage", { kind: "warning", message, ttl }),
    addInformation: (message: string, ttl = 5) =>
      store.commit("msg/addMessage", { kind: "information", message, ttl }),
  };
}
